// extracted by mini-css-extract-plugin
export var layoutContainer = "_e8-0";
export var layoutContainerNoRounding = "_e8-6";
export var layoutContainerOpen = "_e8-5";
export var layoutContainerResizing = "_e8-1";
export var mainContent = "_e8-2";
export var resizeDivider = "_e8-3";
export var slidePanel = "_e8-4";